<template>
  <v-row
    class="d-flex align-center"
    :class="!hideBorderBottom && 'bb'"
  >
    <v-col cols="5">
      <span>{{ labelWithoutLastWord }}</span>
      <span class="label-last-word">
        {{ lastWordInLabel }}
        <v-icon
          class="card-row-required uikit-icon mini-star size-mini-star error"
          v-if="required"
        />
      </span>
    </v-col>

    <v-col cols="7">
      <div
        v-if="disabled && !isEditModeDisabled"
        class="label-text-value"
      >
        {{ isDate && getFormatDate(currentValue) ? getFormatDate(currentValue) + ' г.' : currentValue }}
      </div>
      <slot v-else></slot>
      <transition name="fade">
        <div
          class="pl-3 text-error-message"
          v-if="!disabled && errorMessages && errorMessages.length"
        >
          {{ errorMessages[0] }}
        </div>
      </transition>
    </v-col>
  </v-row>
</template>

<script>
import { getFormatDate } from '@/scripts'

export default {
  name: 'CardRow',
  methods: { getFormatDate },

  props: {
    label: String,
    value: {
      type: [Object, String, Number, Array],
      default: ''
    },
    hideBorderBottom: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isEditModeDisabled: {
      type: Boolean,
      default: false
    },
    itemText: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array | null | undefined
    },
    isDate: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    labelWithoutLastWord() {
      return this.label?.split(' ').slice(0, -1).join(' ')
    },
    lastWordInLabel() {
      return this.label?.split(' ').at(-1)
    },

    currentValue() {
      return this.itemText ? this.value && this.value[this.itemText] : this.value
    }
  },

  filters: {
    shortText(value) {
      if (typeof value === 'number') return value
      if (!value) return ''
      else {
        if (value.length > 45) return value.slice(0, 45) + '...'
        else return value
      }
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.label-last-word {
  white-space: nowrap;
}

.card-row-required {
  vertical-align: top;
}
</style>
